import { createApi } from '@reduxjs/toolkit/dist/query/react';
import axiosBaseQuery from '../../../axios/axiosBaseQuery';
import Util from '../../../util/Util';
import convertPromiseToQueryReturnValue from '../../../axios/convertPromiseToQueryReturnValue';
import DeviceCalls from './DeviceCalls';
import { DeviceDataAPIResponse } from './device.model';
import { deviceListSchema, DeviceStructure } from './adapter/CommanderAdapter';
import { normalize } from 'normalizr';
import { Base64 } from '../../../util/Base64';

// for the moment is empty to split the resources in many files
export const CommanderAPI = createApi({
  reducerPath: 'commander',
  // 1 day
  keepUnusedDataFor: 60 * 60 * 24,
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'commander-data',
    'commander-associated',
    'commander-status',
    'device-configuration',
  ],
  endpoints(build) {
    return {
      getAssociatedDevices: build.query({
        query: () => ({
          url: `${new Util().getCommanderManagementURL()}/`,
        }),
        transformResponse: (data: DeviceDataAPIResponse[]) =>
          normalize(data, deviceListSchema) as DeviceStructure,
        providesTags: ['commander-data', 'commander-associated'],
      }),
      getCommandersByIds: build.query({
        queryFn: (ids: string[]) => {
          const response = new DeviceCalls()
            .getDevicesDataByIds(ids.map(Base64.encode))
            .then(
              (data) => normalize(data, deviceListSchema) as DeviceStructure
            );
          return convertPromiseToQueryReturnValue(response);
        },
        providesTags: ['commander-data'],
      }),
      getCommanderBySerialNumber: build.query({
        queryFn: async (serialNumber: string) => {
          const response = new DeviceCalls().getDeviceBySerialNumber(
            serialNumber
          );
          return await convertPromiseToQueryReturnValue(response);
        },
        providesTags: ['commander-data'],
      }),
      setTimezoneCommander: build.mutation<
        string,
        { commanderId: string; timezone: string }
      >({
        query: ({ commanderId, timezone }) => {
          const encodedCommanderId = Base64.encode(commanderId);
          return {
            url: `${new Util().getDeviceConfigServiceURL()}/${encodedCommanderId}`,
            method: 'put',
            data: [
              {
                key: 'device-timezone',
                value: timezone,
                type: 'TEXT',
              },
            ],
          };
        },
        invalidatesTags: ['commander-data'],
      }),
      getCommanderDetails: build.query({
        queryFn: async (encodedUUID: string) => {
          const response = new DeviceCalls().getDeviceById(encodedUUID);
          return await convertPromiseToQueryReturnValue(response);
        },
        providesTags: ['commander-data'],
      }),
    };
  },
});
